import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { assetUrl } from 'src/app/globals/globals';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { CategoryService } from 'src/app/services/api/categories/category.service';
import { LocationService } from 'src/app/services/api/location/location.service';
import { SliderService } from 'src/app/services/api/sliders/slider.service';
import SwiperCore, { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

declare global {
  interface Window { dataLayer: any[]; }
}

declare var google: any;

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss']
})



export class BenefitsComponent implements OnInit, AfterViewInit {
  keywordSubject: Subject<string> = new Subject();
  assetUrl = assetUrl;
  @ViewChild('swiperRef', { static: false }) swiper?: SwiperComponent;
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;
  @ViewChild('swiperHero', { static: false }) swiperHero?: SwiperComponent;
  @ViewChild('swiperCategories', { static: false }) swiperCategories?: SwiperComponent;

  config: SwiperOptions = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      clickable: true,
    },
    slidesPerView: 1.1,
    breakpoints: {
      1280: {
        slidesPerView: 1.12,
      },
    },
    preventClicksPropagation: false,
    speed: 600,
    centeredSlides: true,
    spaceBetween: 10,
    initialSlide: 0,
    rewind: true
  };
  configCategories: SwiperOptions = {
    navigation: {
      nextEl: '.swiper-button-next-categories',
      prevEl: '.swiper-button-prev-categories',
    },
    preventClicksPropagation: false,
    speed: 600,
    slidesPerView: 2.3,
    spaceBetween: 10,
    breakpoints: {
      1280: {
        slidesPerView: 9.5,
      },
      1000: {
        slidesPerView: 8.5,
      },
      900: {
        slidesPerView: 7.2,
      },
      700: {
        slidesPerView: 5.8,
      },
      450: {
        slidesPerView: 3.4,
      },
    },
  };  
  configBenefits: SwiperOptions = {
    loop: true,
    autoplay: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      type: 'bullets',
      dynamicBullets: true,
    },
    slidesPerView: 1.1,
    breakpoints: {
      1280: {
        slidesPerView: 1.12,
      },
    },
    preventClicksPropagation: false,
    speed: 600,
    centeredSlides: true,
    spaceBetween: 10,
    initialSlide: 0,
    rewind: true,
    loopAdditionalSlides: 4
  };
  swiperConfig: SwiperOptions = {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        dynamicBullets: true,
        clickable: true,
      },
      slidesPerView: 1.1,
      breakpoints: {
        1280:{
          slidesPerView: 1.12,
        },
      },
      loop: true,
      preventClicksPropagation: false,
      speed: 600,
      centeredSlides: true,
      spaceBetween: 10,
      loopAdditionalSlides: 40,
      initialSlide: 0
  };
  benefits: any = [];
  benefitsDiscount: any = [];
  categoriesTag: FormGroup;
  categories: any = [];
  displayedBenefits: any = [];
  loadingCategories = true;
  loadingBenefits = true;
  urlId = 0;
  urlName = '';
  selectedOption = '1';
  selectedCategory: any = null;
  filterSelected: string[] = []
  ordersTag: FormGroup;
  filterUrl = this.benefitsService.url_filters;
  intervalo:any;
  filterCtrl = new FormControl();
  toggle: boolean = true;
  markers = <any>[];
  currentColor = {
    map: '#FFFFFF',
    list: '#595959'
  }
  sliders: any = [];

  keywords: string = '';

  keywords_prefix: string = 'palabra-clave-';

  lat_data = this.benefitsService.data_latitud;
  lon_data = this.benefitsService.data_longitud;
  mapa_data = this.benefitsService.data_mapa;
  ord_data = this.benefitsService.data_ordenamiento;
  showFilterMobile : boolean = false;

  waitText = 'Aguarde un momento, estamos cargando su solicitud.'

  orders: any = [{id: 3, 'Más Relevantes': false, label: 'Más relevantes', url: 'mas-relevantes'},{id: 2, 'Mayor Descuento': false, label: 'Mayor Descuento', url: 'mayor-descuento' }, {id: 4, 'A-Z': false, label: 'A-Z', url: 'a-z'}, {id: 5, 'Z-A': false, label: 'Z-A', url: 'z-a'}]


  panelOpenState = false;
  categorySelected: boolean = false;

  items = [
    { imgUrl: 'assets/images/banner/BannerBenefitDesktop.jpg' },
  ];
  itemsMobile = [
    { imgUrlMobile: 'assets/images/banner/BannerBenefitMobile.jpg' },
  ];
  isMobile: boolean = window.innerWidth <= 1000;
  filtersCount: number = 0;

  constructor(
    fb: FormBuilder,
    private benefitsService: BenefitsService,
    private categoryService: CategoryService,
    private activatedRoute: ActivatedRoute,
    private locationService: LocationService,
    private sliderService: SliderService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

    this.urlId = Number.parseInt( activatedRoute.snapshot.params['id'] );
    this.urlName = this.activatedRoute.snapshot.params['category'];

    this.setCategory( this.categoryService.selectedCategory );
    this.categoryService.selectedCategoryChange.subscribe((cat) => this.setCategory( cat ));
    this.ordersTag = fb.group(this.orders.reduce((a: any, v: any) => ({ ...a, [v.label]: v[v.label]}), {}));

    this.locationService.currentPosition().then( pos => {
      if(pos !== false){
        this.lon_data = pos.lng
        this.lat_data = pos.lat
        this.orders.push({id: 1, 'Más Cercanos':false, label: 'Más Cercanos', url: 'mas-cercanos'})
      }
    }).then(() => {
      this.readUrlParams();
    });
   }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
        return false;
    };
    this.getCategories();
    this.getBenefitsDiscount();
    this.showFilterMobile = !this.isMobile;

    this.keywordSubject.pipe(
      debounceTime(1500),
      distinctUntilChanged()
    ).subscribe((keyword: string) => {
      this.keywords = keyword;
      this.applyKeywordFilter();
    });
  }
  onKeywordChange(event: any): void {
    const value = event.target.value;
    this.keywordSubject.next(value);
  }

  ngAfterViewInit() {
    if (this.swiper && this.swiper.swiperRef) {
      this.swiper.swiperRef.update();
    }
  }

  onFiltersUsed(count: number) {    
    this.filtersCount = count;
  }
    
  getPictureItem(item: any) {
    if(window.innerWidth < 1000)
        return item.benefit?item.benefit.photo_mobile:item.photo_mobile;
    else
        return item.benefit?item.benefit.photo:item.photo;
  }

  getSlider(category:any) {
    let tthis = this;
    this.sliderService
      .getCurrent()
      .toPromise()
      .then((sliders: any) => {
        let slidersCategoria = sliders.filter((e:any) => e.slider_Type.name == 'Beneficios' && category.includes(e.category.id)).sort((a: any, b: any) => a.order - b.order);
        if(slidersCategoria.length > 0) {
          tthis.sliders = slidersCategoria;
        }
      });
  }

  showMobileFilter() {
    this.showFilterMobile = !this.showFilterMobile;
  }

  navigate(item:any) {
    if(item.url && !item.benefit)
      window.open(item.url, "_blank");
  }

  hideMobileFilter() {
    this.showFilterMobile = false;
  }

  readUrlParams(){
    var category = this.activatedRoute.snapshot.params['category'];
    var url = this.filterUrl

    if(category != undefined){
      //handle keyword filter
      if(category.includes(this.keywords_prefix)){
        let keyword_handler = category.split(this.keywords_prefix);

        if(keyword_handler.length > 1){
          this.keywords = keyword_handler[1];
        }
      }

      let flag = false

      this.orders.forEach((item:any, i:any )=>{
        if(category.includes(item.url)){
          this.orders[1][this.orders[1].label] = false

          this.ord_data = item.id;
          this.orders[i][item.label] = true
          if(!url.includes(this.orders[i].url)){
            url.push(this.orders[i].url)
          }

          flag = true
        }
      });

      if(flag == false){
        this.ord_data = 3;
        this.orders[1][this.orders[1].label] = true
        if(!url.includes(this.orders[1].url)){
          url.push(this.orders[1].url)
        }
      }

    }else{
      this.ord_data = 3;
      this.orders[1][this.orders[1].label] = true
    }

    this.getBenefits()
  }

  toggleView(isList: boolean){
    this.toggle = isList;

    if(this.toggle == false){
      this.mapa_data = true
      this.getBenefits()
      this.currentColor = {
        list: "#FFFFFF",
        map: "#595959"
      }
    }

    if(this.toggle == true){
      this.mapa_data = false
      this.getBenefits()
      this.currentColor = {
        list: "#595959",
        map: "#FFFFFF"
      }
    }
  }

  getUrlCategoryName(cat: any): string {
    var cat_nombre = (cat["name"]).replace(/ /g, '-');
    cat_nombre = cat_nombre.toLowerCase();
    cat_nombre = cat_nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return cat_nombre;
  }

  selectCategoryCode(cat: any): void {
    this.categoryService.setSelected(cat);
  }




  addCategories(event:any): void {
    const selected = this.filterSelected;

    const value = this.categoriesTag.value;
    const valueArray = Object.entries(value);
    const filtered = valueArray.filter(([key, value]) => value == true);
    const falseFiltered = valueArray.filter(([key, value]) => value == false);

    // Add our filter
    filtered.forEach((category, i) => {
      if( !selected.includes(category[0]) ){
        var urlFilter = this.getUrlName(category[0])

        this.filterUrl.push(urlFilter)
        selected.push(category[0])

        this.setearIntervalo(this.filterUrl)
      }
    })

    // Remove our filter
    falseFiltered.forEach((category, i)=>{
      if( selected.includes(category[0]) ){
        var index = selected.indexOf(category[0]);
        if (index !== -1) {
          this.filterUrl.splice(index, 1)
          selected.splice(index, 1);
        }

        this.setearIntervalo(this.filterUrl)
      }
    })

    this.filterCtrl.setValue(null);
  }

  changeKeywordFilter(event: any){
    this.keywords = event.target.value;
  }

  applyKeywordFilter(){
    var newFilter = this.filterUrl.filter(e => e.indexOf(this.keywords_prefix) != -1);

    this.filterUrl = newFilter

    if(this.keywords.trim().length > 0){
      this.filterUrl.push(this.keywords_prefix + this.keywords)
    }

    this.benefitsService.filter_benefits(this.filterUrl);

    return false;
  }

  selectOrder(event: any){

    this.orders.forEach((item:any, i:any)=>{
      if(this.filterUrl.includes(item.url)){
        var newFilter = this.filterUrl.filter(e => e !== item.url);

        this.filterUrl = newFilter
      }

      if(event.target.value == item.id){
        this.ord_data = item.id
        this.filterUrl.push(item.url)

        setTimeout(()=>{
          this.benefitsService.filter_benefits(this.filterUrl);
        }, 500);
      }

    });

  }

  setearIntervalo(filterurl:string[]){
    if(this.intervalo != undefined){
      clearInterval(this.intervalo)
    }

    this.intervalo = setInterval(()=>{
      this.benefitsService.filter_benefits(filterurl);
    }, 2000);

  }

  getUrlName(filter: string){
    var filter_name = filter.replace(/ /g, '-');
    filter_name = filter_name.replace(/\//g, '-');
    filter_name = filter_name.replace("%", 'porcentaje');
    filter_name = filter_name.toLowerCase();
    filter_name = filter_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return filter_name;
  }

  filterByCategory(cat: any): void {
    if (cat !== null) {
      this.benefitsService.data_category = [cat.id];
    } else {
      this.benefitsService.data_category = [];
    }

    if (cat !== null) {
      this.displayedBenefits = this.benefits.filter((e: any) => 
        e.redeemCodes === true
      );
    } else {
      this.displayedBenefits = this.benefits.filter((e: any) => e.redeemCodes === true);
    }

  }

  async getBenefits(){
    let tthis = this;
    this.loadingBenefits = true;
    this.benefitsService.filterBenefits(this.lat_data, this.lon_data, this.mapa_data, this.ord_data, this.keywords).toPromise().then((res)=>{
      tthis.benefits = res;

      if(tthis.benefits.length == 0){
        this.loadingBenefits = false;
        tthis.waitText = 'No se encontraron beneficios para las categorías seleccionadas.'
      }
    }).then(()=>{
      tthis.selectedCategory = tthis.categoryService.selectedCategory;
      tthis.filterByCategory(tthis.selectedCategory);
      if(tthis.benefitsService.data_category.length > 0) {
        tthis.getSlider(tthis.benefitsService.data_category);
        tthis.categorySelected = true;
      }
      this.loadingBenefits = false;

      setTimeout(function(){
        tthis.loadingBenefits = false;
      }, 500)

      if(tthis.mapa_data == true){
        setTimeout(() => { tthis.setMap() }, 500);
      }

    })

    const user = localStorage.getItem('user');
    if(user) {
      var currentUser = JSON.parse(user);

      window.dataLayer = window.dataLayer ||
      [];
      window.dataLayer.push({
      'event' : 'lista-beneficios',
      'userId' : currentUser.PersonID
      });
    }
  }

  setCategory( category: any )
  {
    this.selectedCategory = category;
    this.filterByCategory(category);

  }

  getCategory() {
    return this.selectedCategory;
  }

  selectCategory(cat: any): void {
    //this.catSer.setSelected(cat);
    if(isPlatformBrowser(this.platformId)) {   
      if(cat) {
        var cat_nombre = this.getUrlCategoryName(cat);
        document.location.href='beneficios-y-descuentos/' + cat_nombre ;
      } else {
        document.location.href='beneficios-y-descuentos';
      }
    }
  }




  getCategories()
  {
    return this.categoryService.getAll().toPromise()
    .then((response: any) =>
    {
      this.categories = response.sort((a: any, b: any) => {
        if (a.name.toLowerCase() === 'hot sale') return -1;
        if (b.name.toLowerCase() === 'hot sale') return 1;
        return a.stared ? -1 : 1;
      });      
      this.loadingCategories = false;
      if( this.urlName )
      {
        const selected = this.categories
        .find( ( category: any ) =>
        {
          if( this.getUrlCategoryName(category) === this.urlName )
            return category;
        });

        if( selected )
          this.selectCategoryCode( selected );
      }

      if(this.urlId) {
        let idUrl = this.urlId;
        const selected = this.categories
        .find( ( category: any ) =>
        {
          if( (category.id == idUrl) &&( isPlatformBrowser(this.platformId)) )
            document.location.href='./beneficios-y-descuentos/' + this.getUrlCategoryName(category);
        });
      }

      this.categories.forEach((category: any) => {
        category.redirect = category.name;
        category.redirect = category.name.replaceAll(' ', '-');
        category.redirect = category.redirect.toLowerCase();
        category.redirect = category.redirect.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      })
    });
  }


  getBenUrl(ben: any): string {
    if(ben.name)
      return '/beneficios-y-descuentos/' + this.getUrlCategoryName(ben.category) + '/' + ben.name;
    else
      return '/benefit-details/' + ben.id;
  }

  setMap(): void{
    if( this.gmap && isPlatformBrowser(this.platformId) ){

      const styles:  any[] = [];

      styles.push({ elementType: 'geometry',                  stylers: [{ color: '#f5f5f5'}]});
      styles.push({ elementType: 'labels.icon',               stylers: [{ visibility: 'off'}]});
      styles.push({ elementType: 'labels.text.fill',          stylers: [{ color: '#616161'}]});
      styles.push({ elementType: 'labels.text.stroke',        stylers: [{ color: '#f5f5f5'}]});
      styles.push({ featureType: 'administrative.land_parcel',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#bdbdbd'}]});
      styles.push({ featureType: 'poi',
                    elementType: 'geometry',                  stylers: [{ color: '#eeeeee'}]});
      styles.push({ featureType: 'poi',
                    elementType: 'labels.text.fill',          stylers: [{color: '#757575'}]});
      styles.push({ featureType: 'poi.park',
                    elementType: 'geometry',                  stylers: [{ color: '#e5e5e5'}]});
      styles.push({ featureType: 'poi.park',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#9e9e9e'}]});
      styles.push({ featureType: 'road',
                    elementType: 'geometry',                  stylers: [{ color: '#ffffff'}]});
      styles.push({ featureType: 'road.arterial',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#757575'}]});
      styles.push({ featureType: 'road.highway',
                    elementType: 'geometry',                  stylers: [{ color: '#dadada'}]});
      styles.push({ featureType: 'road.highway',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#616161'}]});
      styles.push({ featureType: 'road.local',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#9e9e9e'}]});
      styles.push({ featureType: 'transit.line',
                    elementType: 'geometry',                  stylers: [{ color: '#e5e5e5'}]});
      styles.push({ featureType: 'transit.station',
                    elementType: 'geometry',                  stylers: [{ color: '#eeeeee'}]});
      styles.push({ featureType: 'water',
                    elementType: 'geometry',                  stylers: [{ color: '#9cc0f9'}]});
      styles.push({ featureType: 'water',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#9cc0f9'}]});


      const map        = new google.maps.Map( this.gmap.nativeElement , { styles, disableDefaultUI: false, scrollwheel: true, gestureHandling: 'greedy', draggable: true });

      this.setMapBranches( map );
    }
  }

  setMapBranches( map: any ){
    if (isPlatformBrowser(this.platformId)) {
    const bounds    = new google.maps.LatLngBounds();

      this.benefits.forEach( ( item: any ) =>
      {
        const icon        = assetUrl('assets/images/marker.png');
        const position    = new google.maps.LatLng( item.branch[0].branch.latitude, item.branch[0].branch.longitude );
        const pixelOffset = new google.maps.Size(0, 0)
        const content     = '<div class="marker-content">' +
                            '<div class="marker-body-benefits">' +
                              '<a href=' + this.getBenUrl(item) + '><div class="thumb-top img-marker" style="background:url(' + item.thumb + ')"><div class="thumb-caption-marker"><div class="thumb-mark"><img src="' + item.partner?.logo + '"/></div></div></div></a>' +
                              '<p class="marker-name">' + item.branch[0].branch.name + '</p>' +
                              '<p class="marker-address">'+ item.branch[0].branch.address + '</p>' +
                            '</div>' +
                          '</div>';
        const infoWindow = new google.maps.InfoWindow({ content, pixelOffset });
        const marker     = new google.maps.Marker({ position, map, icon });

        marker.addListener('click', () => infoWindow.open( map, marker ));
        marker.setMap( map );

        this.markers.push( position );
      });



    this.markers.forEach(( mark: any ) => bounds.extend( mark ));
    this.centerMap( map, bounds );
    }
  }

  centerMap( map: any, bounds: any ){
    if( this.markers.length > 1 )
    map.fitBounds( bounds );

    if (navigator.geolocation) {
      let markers = this.markers;

      navigator.geolocation.getCurrentPosition((position) => {

        var initialLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        map.setCenter(initialLocation);

        var currentLocation = new google.maps.Marker({ position: initialLocation, map });
        currentLocation.setMap( map );

        setBounds();

        function rad(x:any){
          return x*Math.PI/180;
        }

        var lat = initialLocation.lat();
        var lng = initialLocation.lng();

        function nearestMarker() {
          var R = 6371; // radius of earth in km
          var distances = [];
          var closest = -1;

          for( let i=0; i< markers.length; i++ ) {
            var mlat = markers[i].lat();
            var mlng = markers[i].lng();
            var dLat  = rad(mlat - lat);
            var dLong = rad(mlng - lng);

            var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            var d = R * c;

            distances[i] = d;

            if ( closest == -1 || d < distances[closest] ) {
              closest = i;
            }
          }

          return markers[closest];
        }

        function setBounds(){
          var closestMarker = nearestMarker();

          var bounds = new google.maps.LatLngBounds();
          bounds.extend(closestMarker);
          bounds.extend(initialLocation);
          map.fitBounds(bounds);
        }

      });
    }else if( this.markers.length > 1 )
      map.fitBounds( bounds );
    else{
      const position = this.markers[0];
      map.setCenter( position );
      map.setZoom( 15 );
    }
  }

  slideNext(){
    this.swiperHero?.swiperRef.slideNext(100);
  }
  slidePrev(){
    this.swiperHero?.swiperRef.slidePrev(100);
  }

  slideNextCategories(){
    this.swiperCategories?.swiperRef.slideNext(150);
  }
  slidePrevCategories(){
    this.swiperCategories?.swiperRef.slidePrev(150);
  }

  async getBenefitsDiscount() {
    let tthis = this;
    this.benefitsService.get().toPromise().then((res) => {
        tthis.benefits = res;
        tthis.benefitsDiscount = tthis.benefits.filter((benefit: any) => benefit.redeemCodes === false);
    })
  }
}
